import {makeStyles} from '@mui/styles'
import {FC} from 'react'

import {ChatMessageTemplates, WhatsappMessages} from '../../../types/graphqlSchema'
import ChatMessageTemplateButtonList
  from '../../chatMessageTemplate/ChatMessageTemplateButtonList'
import {ExternalLinkIcon} from '../../icons'

const ChatMessageTemplateActionButton: FC<ChatMessageTemplateActionButtonProps> = ({
  template,
  whatsappMessage,
}) => {
  const styles = useStyles()
  return (
    <div>
      {template.buttonText && (
        <div className={styles.buttonTextContainer}>
          <ExternalLinkIcon />
          <a href={template.buttonUrl as string} rel="noreferrer" target="_blank">
            {template.buttonText}
          </a>
        </div>
      )}
      {template.chatMessageTemplateButtons && (
        <ChatMessageTemplateButtonList
          chatMessageTemplateButtons={template?.chatMessageTemplateButtons}
          whatsappMessage={whatsappMessage}
        />
      )}
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  buttonTextContainer: {
    '& a': {
      color: theme.palette.info.main,
      fontWeight: 600,
      textDecoration: 'none',
    },
    alignItems: 'start',
    borderTop: `1px solid ${theme.palette.disabled.main}`,
    color: theme.palette.info.main,
    display: 'flex',
    fill: theme.palette.info.main,
    justifyContent: 'center',
    paddingTop: theme.remSpacing(1),
  },
}))

interface ChatMessageTemplateActionButtonProps {
  template: ChatMessageTemplates
  whatsappMessage: WhatsappMessages
}

export default ChatMessageTemplateActionButton
